import styled from 'styled-components'

export const OrderNumberAndDateContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
